module.exports = __webpack_public_path__ + "img/icon-checkbox-checked.2aa24afc.svg";